<app-collapse
  [title]="'P00045.parametre.status.cloud' | translate"
  [warning]="
    actionStack!.getValue('cnSEtatConnexionMQTT') === 0 ||
    actionStack!.getValue('cnSEtatConnexionHTTPS') === 0
  "
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00045.parametre.status.cloud.etatCo' | translate"
      [value]="
        actionStack!.getValue('cnSEtatConnexionHTTPS') === 0
          ? ('P00045.parametre.status.deconnecte' | translate)
          : ('P00045.parametre.status.connecte' | translate)
      "
    />
    <app-display-rubrique-status
      [title]="'P00045.parametre.status.cloud.tpsReel' | translate"
      [value]="
        actionStack!.getValue('cnSEtatConnexionMQTT') === 0
          ? ('P00045.parametre.status.deconnecte' | translate)
          : ('P00045.parametre.status.connecte' | translate)
      "
    />
  </div>
</app-collapse>

@if (isSupportTechnique()) {
  <app-collapse [title]="'P00045.parametre.status.historique' | translate">
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="'P00045.parametre.status.memoireHistoriue' | translate"
        [value]="
          actionStack!.getValue('cnSEtatPurgeHistorique') === 0
            ? ('P00045.parametre.status.ok' | translate)
            : ('P00045.parametre.status.saturee' | translate)
        "
      />
      <app-display-rubrique-status
        [title]="'P00045.parametre.status.debPurge' | translate"
        [value]="
          actionStack!.getValue('cnSDebutPurge').indexOf('01/01/1900') > -1
            ? '-'
            : actionStack!.getValue('cnSDebutPurge')
        "
      />
      <app-display-rubrique-status
        [title]="'P00045.parametre.status.finPurge' | translate"
        [value]="
          actionStack!.getValue('cnSFinPurge').indexOf('01/01/1900') > -1
            ? '-'
            : actionStack!.getValue('cnSFinPurge')
        "
      />
    </div>
  </app-collapse>
}

<app-collapse
  [title]="'P00045.parametre.status.internet' | translate"
  [warning]="hasProductWarning() !== 1"
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00045.parametre.status.internet.connexion' | translate"
      [value]="
        actionStack!.getValue('cnSEtatConnexionEthernet') === 0
          ? ('P00045.parametre.status.deconnecte' | translate)
          : ('P00045.parametre.status.connecte' | translate)
      "
    />

    <app-display-rubrique-status
      [title]="'P00045.parametre.status.internet.wifi' | translate"
      [value]="
        actionStack!.getValue('cnSEtatConnexionWifi') === 0
          ? ('P00045.parametre.status.deconnecte' | translate)
          : ('P00045.parametre.status.connecte' | translate)
      "
    />

    <app-display-rubrique-status
      [title]="'P00045.parametre.status.internet.qualiteWifi' | translate"
      [value]="actionStack!.getValue('cnSRSSIWifi') + ' %'"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00045.status.coProduit' | translate"
      [warning]="hasProductWarning() === 2"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00045.status.ok' | translate"
    />

    <app-display-rubrique-status
      [title]="'P00045.parametre.status.internet.qualiteZB' | translate"
      [value]="
        deviceTableData.qualityZB === -1
          ? '--'
          : deviceTableData.qualityZB + ' %'
      "
    />
  </div>
</app-collapse>

@if (isSupportTechnique()) {
  <app-collapse [title]="'P00045.parametre.status.supervision' | translate">
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurPowerCycle'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurPowerCycle')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurResetTacheACWA'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurResetTacheACWA')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurResetTacheZ3'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurResetTacheZ3')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSMaximumJournalierEspaceFlashUtilise'
            | translate
        "
        [value]="
          actionStack!.getValue('cnSMaximumJournalierEspaceFlashUtilise')
        "
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurAccessFichier'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurAccessFichier')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurErreurAccessFichier'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurErreurAccessFichier')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurAPIPThread'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurAPIPThread')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurErreurAPIPThread'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurErreurAPIPThread')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSMaximumJournalierRAMUtilise'
            | translate
        "
        [value]="actionStack!.getValue('cnSMaximumJournalierRAMUtilise')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurPublishMQTT'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurPublishMQTT')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurErreurPublishMQTT'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurErreurPublishMQTT')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurRequetesHTTP'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurRequetesHTTP')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurErreursCURL'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurErreursCURL')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurErreursHTTP'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurErreursHTTP')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurReportsZigbee'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurReportsZigbee')"
      />

      <app-display-rubrique-status
        [title]="
          'P00045.parametre.status.supervision.cnSCompteurErreurReportZigbee'
            | translate
        "
        [value]="actionStack!.getValue('cnSCompteurErreurReportZigbee')"
      />
    </div>
  </app-collapse>
}
